export const featureFlags = {
  externalAppointment:
    process.env.REACT_APP_FEATURE_FLAG_ENABLE_EXTERNAL_APPOINTMENT === 'TRUE',
};
